import Model from './Model';

export default class Notification extends Model {
  resource() {
    return 'notifications';
  }

  // Get unread notifications
  static unread() {
    return this.request({
      method: 'GET',
      url: `${this.baseURL()}/notifications/unread`
    });
  }

  // Mark notification as read
  markAsRead() {
    return this.request({
      method: 'PATCH',
      url: `${this.baseURL()}/notifications/${this.id}/read`
    });
  }

  // Mark all notifications as read
  static markAllAsRead() {
    return this.request({
      method: 'PATCH',
      url: `${this.baseURL()}/notifications/mark-all-read`
    });
  }

  // Execute action (dismiss, snooze, etc.)
  executeAction(action, data = {}) {
    return this.request({
      method: 'POST',
      url: `${this.baseURL()}/notifications/${this.id}/action`,
      data: {
        action,
        ...data
      }
    });
  }

  // Dismiss notification (mark as read)
  dismiss() {
    return this.executeAction('dismiss');
  }

  // Snooze notification
  snooze(duration = 'P1D') {
    return this.executeAction('snooze', { duration });
  }
}
